import { useContext, useEffect, useState } from "react";
import { ContextStatus } from "@leedpulse-monorepo/enums";
import getPublicationStatus, { EMPTY_PUBLICATION_STATUS, PublicationStatus } from "../../../domain/use_cases/leedflow/overview/getPublicationStatus";
import AuthenticationContext from "../../contexts/auth/AuthenticationContext";

/**
 * État de publication des deux stores. Pas de rafraîchissement automatique : une review de store
 * se compte en heures, et la route est déjà cachée 2 minutes côté backend. Le bouton
 * « Actualiser » de l'onglet couvre le seul moment où on veut du frais, celui où on attend.
 */
export const usePublicationStatus = () => {
    const authContext = useContext(AuthenticationContext);
    const auth = authContext.authentication;
    const [status, setStatus] = useState<PublicationStatus>(EMPTY_PUBLICATION_STATUS);
    const [contextStatus, setContextStatus] = useState<ContextStatus>(ContextStatus.LOADING);
    // Le bouton « Actualiser » relance l'effet en changeant sa dépendance, plutôt qu'en
    // appelant une fonction qui poserait un `setState` depuis l'effet lui-même.
    const [refreshKey, setRefreshKey] = useState(0);

    useEffect(() => {
        if (!auth) return;

        let cancelled = false;

        const load = async () => {
            try {
                const res = await getPublicationStatus(auth);
                if (cancelled) return;
                setStatus(res);
                setContextStatus(ContextStatus.SUCCESS);
            } catch (error) {
                if (cancelled) return;
                console.error(error);
                setContextStatus(ContextStatus.ERROR);
            }
        };

        load();

        return () => {
            cancelled = true;
        };
    }, [auth, refreshKey]);

    const reload = () => {
        setContextStatus(ContextStatus.LOADING);
        setRefreshKey((previous) => previous + 1);
    };

    return { status, contextStatus, reload };
};
